<template>
  <div class="ps-print-input" id="ps-print-input">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <div class="items-container" v-for="item in items.staticImages" :key="item.id">
      <img :style="[setPosition(item.pos)]" :src="giveMeImagePlease(item.src)" alt="" />
    </div>
    <div class="items-container" v-for="item in items.visibleItems" :key="item.id">
      <img
        class="visible-images"
        :class="coolShadows ? 'animated-images-with-shadow' : 'visible-images'"
        @click="showConnectedItem(item.connectId)"
        :style="setPosition(item.pos)"
        :src="giveMeImagePlease(item.src)"
        alt=""
      />
    </div>
    <div class="items-container" v-for="item in items.hiddenItems" :key="item.id">
      <img
        :style="[setPosition(item.pos), item.hidden ? { opacity: 0 } : { opacity: 1 }]"
        style="transition: 0.5s"
        :src="giveMeImagePlease(item.src)"
        alt=""
      />
    </div>
    <div v-if="!printFlagInput">
      <div v-for="inputItem in inputs" :key="inputItem.id + 'input'">
        <input
          :id="'input-' + inputItem.id"
          style="padding: 4px"
          :style="[
            setPosition(inputItem.pos),
            {
              'font-family': `${startGameConfig.inputFontStyle.font}`,
              'font-size': `${startGameConfig.inputFontStyle.size}`,
            },
          ]"
          v-model="inputTab[inputItem.id].val"
          type="text"
        />
      </div>
    </div>
    <div v-else>
      <div v-for="inputItem in inputs" :key="inputItem.id + 'input'">
        <div
          :style="[
            setPosition(inputItem.pos),
            {
              'text-align': 'left',
              padding: '4px',
              'font-family': `${startGameConfig.inputFontStyle.font}`,
              'font-size': `${startGameConfig.inputFontStyle.size}`,
              background: 'white',
            },
          ]"
        >
          {{ inputTab[inputItem.id].val }}
        </div>
      </div>
    </div>
    <div :style="printFlag ? { zIndex: 2 } : { zIndex: -20 }" class="print-popup">
      <p style="text-align: center">Nazwa pliku</p>
      <input v-model="fileName" type="text" />
      <button style="margin: 10px; font-size: 1.6rem" @click="print(fileName)">Zapisz</button>
      <button
        style="margin: 10px; font-size: 1.6rem"
        @click="
          printFlag = false;
          fileName = '';
        "
      >
        Anuluj
      </button>
    </div>
    <img
      class="print-button"
      data-html2canvas-ignore
      :class="coolShadows ? 'animated-images-with-shadow' : 'print-button'"
      :style="setPosition(startGameConfig.printButton.pos)"
      @click="saveFile()"
      :src="giveMeImagePlease(startGameConfig.printButton.src)"
      alt=""
    />
  </div>
</template>
<script>
import _ from 'lodash';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
  name: 'ps-print-input',
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      inputTab: [],
      printFlag: false,
      printFlagInput: false,
      fileName: '',
      coolShadows: true,
      items: _.cloneDeep(this.startGameConfig.items),
      inputs: _.cloneDeep(this.startGameConfig.inputs),
    };
  },
  mounted() {
    if (this.startGameConfig.coolShadows) {
      this.coolShadows = this.startGameConfig.coolShadows;
    }
    if (!this.items || !this.items.visibleItems || !this.items.hiddenItems) {
      console.error('Error - check items');
    }
  },
  created() {
    if (this.startGameConfig.coolShadows) {
      this.coolShadows = true;
    } else {
      this.coolShadows = false;
    }
    for (let inp of this.inputs) {
      this.inputTab.push({ val: '' });
    }
  },
  methods: {
    saveFile() {
      this.fileName = '';
      if (!this.$store.getters.isWeb) {
        this.printFlagInput = true;
        this.print('Karta pogody');
      } else {
        this.printFlagInput = true;
        this.printFlag = true;
      }
    },
    print(filename) {
      this.printFlag = false;
      setTimeout(() => {
        // let cw = 0,
        //   ch = 0,
        //   doc = null,
        //   canvasHtml = document.getElementById('ps-print-input')?.getBoundingClientRect();
        // html2canvas(document.querySelector('#ps-print-input'), { backgroundColor: 'null', scale: 1 }).then((cnv) => {
        //   // console.log(cnv);
        //   cw = canvasHtml?.width;
        //   ch = canvasHtml?.height;
        //   // console.log('VIEWPORT', cw, ch);
        //   if (cw > ch) {
        //     doc = new jsPDF({
        //       unit: 'px',
        //       format: [cw, ch],
        //       compress: true,
        //       orientation: 'l',
        //     });
        //   } else {
        //     doc = new jsPDF({
        //       unit: 'px',
        //       format: [cw, ch],
        //       compress: true,
        //       orientation: 'p',
        //     });
        //   }
        //   let imgData = cnv.toDataURL();
        //   doc.setFillColor(255, 255, 255, 0);
        //   doc.rect(0, 0, cw, ch);
        //   doc.addImage(imgData, 'PNG', 0, 0, cw, ch);
        //   if (!this.$store.getters.isWeb) {
        //     doc.save(filename);
        //     this.$electron.shell.openItem(filename);
        //   } else {
        //     doc.save(filename);
        //   }
        // });
        html2canvas(document.querySelector('#ps-print-input')).then((canvas) => {
          let doc = document.createElement('a');
          doc.download = filename + '.png';
          doc.href = canvas.toDataURL('image/png');
          if (!this.$store.getters.isWeb) {
            doc.click();
            // window.location.reload(true);
            // window.location.replace('/');
            // this.$electron.shell.openItem(filename);
          } else {
            doc.click();
          }
        });
        this.printFlagInput = false;
      }, 300);
    },
    showConnectedItem(connectId) {
      if (connectId) {
        for (let hiddenItem of this.items.hiddenItems) {
          if (hiddenItem.id == connectId) {
            let group = hiddenItem.group;
            for (let hiddenItemGroup of this.items.hiddenItems) {
              if (group && hiddenItemGroup.group == group && hiddenItemGroup.id != hiddenItem.id) {
                hiddenItemGroup.hidden = true;
              }
            }
            hiddenItem.hidden = !hiddenItem.hidden;
          }
        }
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    setPosition(pos) {
      if (pos) {
        return {
          position: 'absolute',
          top: pos.y + 'px',
          left: pos.x + 'px',
          width: pos.width + 'px',
          height: pos.height + 'px',
          'z-index': pos.zIndex,
        };
      }
    },
    resetGame() {
      this.items = _.cloneDeep(this.startGameConfig.items);
      this.inputs = _.cloneDeep(this.startGameConfig.inputs);
      for (let item of this.inputTab) {
        item.val = '';
      }
      // this.inputTab = '';
      // let doc = document.getElementById('input-0');
      // doc.value = 'xxxxxxxxx';
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    resetGameSwitch(newStatus, oldStatus) {
      this.resetGame();
      if (newStatus) {
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.print-button {
  transition: 0.3s;
  transform: scale(1);
}
.print-button:hover {
  cursor: pointer;
  transition: 0.3s;
  transform: scale(1.1);
}
.main-img {
  position: fixed;
  object-fit: cover;
}
.items-container {
  position: absolute;
}
.visible-images:hover {
  cursor: pointer;
  transition: 0.3s ease-in-out;
  transform: scale(1.2);
}
.visible-images {
  transition: 0.3s ease-in-out;
  transform: scale(1);
}
.ps-print-input {
  background-size: contain;
  position: relative;
  top: 0px;
  left: 0px;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.animated-images-with-shadow:hover {
  cursor: pointer;
  transition: 0.3s ease-in-out;
  transform: scale(1.2);
  -webkit-filter: drop-shadow(5px 5px 5px #666666);
  filter: drop-shadow(5px 5px 5px #666666);
}
.animated-images-with-shadow {
  transition: 0.3s ease-in-out;
  transform: scale(1);
}
.print-popup {
  background-color: white;
  border-radius: 12px;
  padding: 10px;
  position: fixed;
  left: calc(50% - 250px);
  top: calc(50% - 50px);
  z-index: 300;
  width: 500px;
  height: 230px;
  color: black;
}
</style>
